import {scrollToId, smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";
import {gsap} from "gsap/gsap-core";
import {Swiper} from "swiper";
import {FreeMode} from "swiper/modules";
import {ScrollTrigger} from "gsap/ScrollTrigger";

$(document).ready(function () {
  initVideoBlockPadding();
  window.initTabSwiper();
});

$('body').on('click', '.js--service-switch-tab', function (event) {
  $('.js--service-switch-tab').removeClass('active');
  $(this).addClass('active');

  gsap.set('.js-timeline-block-modal-bold-title, .js-timeline-block-modal-image, .js-timeline-block-modal-content', {
    opacity: 0,
    y: 50
  });


  const tab = $(this).data('service-tab-type');

  var block = document.querySelector(`#${tab}`);
  const information = block.querySelector('.js-category-service-content');
  const title = block.querySelector('.js-category-service-title');
  const image = block.querySelector('.js-category-service-image');


  if (information) {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-content', information.innerHTML);
  }
  if (title) {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-bold-title', title.innerHTML);
  }

  if (image) {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-image', generateImageBlockHtml(image.src, title.innerHTML));
  } else {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-image', '');
  }

  setupModalOpen('#service-modal-wrapper');
  window.initPopupDivider();
  initVideoBlockPadding();
  window.initBasicCarousel();
  gsap.to('.js-timeline-block-modal-bold-title, .js-timeline-block-modal-image, .js-timeline-block-modal-content', {
    opacity: 1,
    y: 0
  });

});

const initVideoBlockPadding = () => {
  if ($('.video-parent-block').length > 0) {
    $('.video-parent-block').each(function () {
      var $videoBlock = $(this);
      var $nextBlock = $videoBlock.next('.block-wrapper');

      if ($nextBlock.find('h2').length > 0) {
        $videoBlock.css('padding-bottom', '1.75rem');
      } else {
        $videoBlock.css('padding-bottom', '0');
      }
    });
  }

  if ($('.video-parent-block').length > 0) {
    $('.video-parent-block').each(function () {
      var $videoBlock = $(this);
      var $nextBlock = $videoBlock.next('.block-wrapper');

      if ($nextBlock.find('h2').length > 0) {
        $videoBlock.css('padding-bottom', '1.75rem');
      } else {
        $videoBlock.css('padding-bottom', '0');
      }
    });
  }
}

window.onCategoryServiceClick = (e, slug, noUrl, meta_title = '', meta_description = '') => {
  const information = e.querySelector('.js-category-service-content');
  const title = e.querySelector('.js-category-service-title');
  const image = e.querySelector('.js-category-service-image');
  const extraServices = e.querySelector('.single-other-service');
  const extraServicesTabs = e.querySelector('.js--service-tabs-to-put');

  if (information) {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-content', information.innerHTML);
  }
  if (title) {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-bold-title', title.innerHTML);
  }

  if (image) {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-image', generateImageBlockHtml(image.src, title.innerHTML));
  } else {
    updateModal('#service-modal-wrapper', '.js-timeline-block-modal-image', '');
  }

  if (extraServices) {
    $('.js--service-without-tabs, .js--service-divider').addClass('d-none');
    $('.js--service-with-tabs').removeClass('d-none');
    updateModal('#service-modal-wrapper', '.js--service-tabs-container', extraServicesTabs.innerHTML);
    $('.js--service-tabs-container .js--service-switch-tab:first').addClass('active');
  } else {
    $('.js--service-without-tabs, .js--service-divider').removeClass('d-none');
    $('.js--service-with-tabs').addClass('d-none');
  }
  if (!noUrl) {
    setUrlCategoryServiceParam(slug);
  }
  updateMeta(false, meta_title, meta_description, false);
  setupModalOpen('#service-modal-wrapper');
  window.initPopupDivider();
  initVideoBlockPadding();
  window.initBasicCarousel();
  window.initTabSwiper();

}

window.onCategoryServiceClose = () => {
  updateMeta(true, null, null, false);
  clearModalContent()
  setUrlCategoryServiceParam(null);
  toggleOverflowHidden(false);
  window.finishTimelineGridAnimation();
}

let tabSwiper;
window.initTabSwiper = () => {
  if (tabSwiper) {
    tabSwiper.destroy(true, true); // Destroy Swiper instance
    tabSwiper = null; // Set swiper to null
  }

  tabSwiper = new Swiper('.js--service-tab-swiper', {
    modules: [FreeMode],
    spaceBetween: 0,
    slidesPerView: 'auto',
    freeMode: {
      enabled: true
    },
    loop: false
  })

  if ($(window).width() < 992) {

    $('.js--service-tab-swiper').find('.swiper-wrapper').delay(300).animate({left: '-80px'}, 600,
      function () {
        $(this).animate({left: 0}, 600)
      })
  }
}

window.onKurbadsProvidesClose = () => {
  updateMeta(true);
  clearModalContent();
  setUrlCategoryServiceParam(null, 'kurbads_provides');
  toggleOverflowHidden(false);
}

window.onKurbadsProvidesOpen = (slug = null, meta_title = '', meta_description = '') => {
  let contentDiv = document.getElementById(slug);
  if (contentDiv) {
    if (slug) {
      setUrlCategoryServiceParam(slug, 'kurbads_provides')
    } else {
      setUrlCategoryServiceParam(null, 'kurbads_provides')
    }

    const information = contentDiv.querySelector('.js-kurbads-provides-content');
    const title = contentDiv.querySelector('.js-kurbads-provides-title');
    const image = contentDiv.querySelector('.js-kurbads-provides-image');
    if (information) {
      updateModal('#kurbads-provides-modal-wrapper', '.js-timeline-block-modal-content', information.innerHTML);
    }
    if (title) {
      updateModal('#kurbads-provides-modal-wrapper', '.js-timeline-block-modal-bold-title', title.innerHTML);
    }
    if (image) {
      updateModal('#kurbads-provides-modal-wrapper', '.js-timeline-block-modal-image', generateImageBlockHtml(image.src, title.innerHTML));
    } else {
      updateModal('#kurbads-provides-modal-wrapper', '.js-timeline-block-modal-image', '');
    }
    updateMeta(false, meta_title, meta_description, false);
    setupModalOpen('#kurbads-provides-modal-wrapper');
  }
}


window.onCategoryServiceSwitch = (category_id, category = null, meta_title = '', meta_description = '') => {
  console.log("category_id :",category_id,": , category = null :",category,": , meta_title = '' :",meta_title,": , meta_description = '' :",meta_description);
  updateMeta(false, meta_title, meta_description);
  if (category) {
    setUrlCategoryServiceParam(category, 'category')
  } else {
    setUrlCategoryServiceParam(null, 'category')
  }
  scrollToId($('.services-image-with-text'));

  $('.services-categories-list .swiper-wrapper .c-btn').removeClass('active');
  $('.js--change-services-category li').removeClass('active-element');
  $(`li[data-services-category="${category_id}"]`).addClass('active-element');
  $(`.swiper-slide[data-services-category="${category_id}"] button`).addClass('active');
  // element.classList.add('active');
  oc.ajax('onServicesCategorySwitch', {
    update: {
      'services/category-content': true,
      'services/sections': true,
    },
    afterUpdate: function () {
      textScroll('h1.js-slice-me');
      window.splitLinesAnimate();
      initImageWithTextSlider();
      window.initImageZoomInEffect();
      window.setupButtonAnimation();
    }
  })
}

const updateModal = (modal, selector, content) => {
  $(`${modal} .inner-children ${selector}`).html(content);
}

const scrollToTopOfModal = (modalSelector) => {
  $(`${modalSelector} .inner-children`).scrollTop(0);
}

const setupModalOpen = (modalSelector) => {
  const modal = $(modalSelector)
  scrollToTopOfModal(modalSelector);
  modal.addClass('modal-active');
  toggleOverflowHidden(true);
  initBasicCarousel();
  initBlocksSwiper();
  initImageWithTextSlider();
}

const setUrlCategoryServiceParam = (slug, type = 'service') => {
  const newUrl = new URL(window.location.href);

  if (slug) {
    newUrl.searchParams.set(type, slug);

    $('.js--lang-switcher-href').each(function () {
      let href = $(this).attr('href');
      if(href) {
        let baseUrl = href.split('?')[0];
        let newHref = baseUrl + `?${type}=${slug}`;
        $(this).attr('href', newHref);
      }
    });
  } else {
    newUrl.searchParams.delete(type);
    let href = $(this).attr('href');
    if(href) {
      let baseUrl = href.split('?')[0];
      $(this).attr('href', baseUrl);
    }
  }
  window.history.pushState({}, '', newUrl);
}

const clearModalContent = () => {
  const modal = $('.js-timeline-block-modal')
  modal.removeClass('modal-active');
  updateModal('.js-timeline-block-modal-content', '');
  updateModal('.js-timeline-block-modal-image', '');
  updateModal('.js-timeline-block-modal-title', '');
  updateModal('.js-timeline-block-modal-bold-title', '');
}

const toggleOverflowHidden = (is_on = false) => {
  if (is_on) {
    $('body').addClass('overflow-hidden');
    $('html').addClass('overflow-hidden');
    smoothScrollPause();
  } else {
    $('body').removeClass('overflow-hidden');
    $('html').removeClass('overflow-hidden');
    smoothScrollPlay();
  }
}


